import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Compliance = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Compliance' {...props}>
    <path fill='none' stroke='#231F20' strokeWidth='2' d='M8,6 L16,6 L16,1 L8,1 L8,6 L8,6 L8,6 Z M16,3 L21,3 L21,23 L3,23 L3,3 L8,3 M8,14 L11,17 L17,11' />
  </StyledIcon>
);
